module.exports = __webpack_public_path__ + "img/logo.2ebbf042.svg";